export default __webpack_public_path__ + "static/media/aprobada.4828dd17.svg";